<section id="subjects" class="section reveal reveal--fade-up" s2eReveal aria-labelledby="subjects-heading">
  <div class="section__head">
    <div class="section__headings">
      <h2 class="section__title" id="subjects-heading">{{ 'subjectTable.title' | reportT }}</h2>
      <p class="section__desc">{{ 'subjectTable.subtitle' | reportT }}</p>
    </div>
  </div>

  <article class="card card--clip" data-print-block>
    <!-- Défile plutôt que d'écraser les colonnes sur écran étroit. -->
    <div class="table-wrap">
      <table class="data-table data-table--subjects">
        <caption class="sr-only">{{ 'subjectTable.caption' | reportT }}</caption>
        <thead>
          <tr>
            <th>{{ 'subjectTable.subject' | reportT }}</th>
            <th class="col-score data-table__end">{{ 'subjectTable.score' | reportT }}</th>
            <th class="col-pct">{{ 'subjectTable.percentage' | reportT }}</th>
            <th class="col-status data-table__end">{{ 'subjectTable.level' | reportT }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows(); track row.subjectId) {
            <tr [class.is-highlighted]="row.highlighted">
              <td class="data-table__subject">
                <span class="data-table__subject-inner">
                  <span>{{ row.subjectName }}</span>
                  @if (row.highlighted) {
                    <span class="badge badge--primary badge--sm">{{ 'header.test' | reportT }}</span>
                  }
                </span>
              </td>
              @if (row.hasDiagnostic) {
                <td class="data-table__num"><span dir="ltr" class="fraction tabular">{{ 'summary.points' | reportT: row.pointsVars }}</span></td>
                <td>
                  <div class="meter-row">
                    <div [class]="row.meterClass" aria-hidden="true">
                      <div class="meter__fill reveal reveal--meter" data-meter-fill
                           [style.--meter-target.%]="row.percentage"
                           s2eReveal [revealDelay]="$index * 80"></div>
                    </div>
                    <span class="meter-row__value tabular">{{ row.percentage | reportFmt: 'pct' }}</span>
                  </div>
                </td>
                <td class="data-table__end">
                  <span [class]="row.badgeClass">{{ row.levelLabel }}</span>
                </td>
              } @else {
                <!-- Diagnostic pas encore passé : les trois cellules disent
                     l'attente, à la place de zéros qui se liraient comme un
                     résultat. La mention est de l'habillage applicatif, d'où
                     la clé hors du domaine `REPORT`. -->
                <td class="data-table__end" colspan="3">
                  <span class="badge badge--neutral badge--md">{{ 'DIAGNOSTIC_REPORT.NOT_TAKEN' | translate }}</span>
                </td>
              }
            </tr>
          }
        </tbody>
        @if (overall(); as total) {
          <tfoot>
            <tr>
              <td class="data-table__total">{{ 'subjectTable.average' | reportT }}</td>
              <td class="data-table__num data-table__total"><span dir="ltr" class="fraction tabular">{{ 'summary.points' | reportT: total.pointsVars }}</span></td>
              <td>
                <div class="meter-row">
                  <div [class]="total.meterClass" aria-hidden="true">
                    <div class="meter__fill reveal reveal--meter" data-meter-fill
                         [style.--meter-target.%]="total.percentage"
                         s2eReveal [revealDelay]="total.delay"></div>
                  </div>
                  <span class="meter-row__value meter-row__value--bold tabular">{{ total.percentage | reportFmt: 'pct' }}</span>
                </div>
              </td>
              <td class="data-table__end">
                <span [class]="total.badgeClass">{{ total.levelLabel }}</span>
              </td>
            </tr>
          </tfoot>
        }
      </table>
    </div>
  </article>
</section>
